<template>
    <div>
        <div v-if="!is_pay" class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':viewToggle||!clickToggle,'d-none':viewToggle||!clickToggle}">
            <div class="right_list_content">
                <div style="line-height: 65px;">
                    <p id="right_content_title_information" class="pl-3 mb-0">
                        <i class="fa fa-folder-open fa-lg mr-2"></i>知识产权
                    </p>
                </div>
                <div>
                    <div class="d-flex flex-wrap right_information_dropdown">
                        <div class="text-muted flex-fill col-6 m-0" v-if='!rowOne'>
                            <div class="dropdown" >
                                <li  class="dropdown-toggle" data-toggle="dropdown">
                                    <span class="beyond_one">{{nationsSelected}}</span>
                                </li>
                                <div class="dropdown-menu nano statenano" style="height: auto;">

                                    <div class="nano-content nano-contents">

                                        <a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateClassifys(value)" href="javascript:">{{value.name}}</a>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 m-0 text-muted flex-fill" v-if="rowOne"></div>
                        <div class="col-4 m-0 text-muted flex-fill" v-if="rowOne">
                            <div class="dropdown" >
                                <a href="javascript:" class="dropdown-toggle" data-toggle="dropdown">
                                    <span class="beyond_one">{{this.nationsSelected}}</span>
                                </a>
                                <div class="dropdown-menu nano" style="height: auto;width: 195px;">

                                    <div class="nano-content nano-contents">
                                        <a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateClassifys(value)" href="javascript:">{{value.name}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 m-0 text-muted flex-fill" v-if='!rowOne&&rowTwo'>
                            <div class="dropdown" >
                                <li class="dropdown-toggle" data-toggle="dropdown">
                                    <span class="beyond_one">{{this.industrysSelected}}</span>
                                </li>
                                <div class="dropdown-menu nano abs nmd"  style="height:auto; width: 300px;">
                                    <div class="nano-content nano-contents">
                                        <a class="dropdown-item"  v-for="(value, key) in twoRowData" @click="filtrateindustry(key,value)" href="javascript:">{{value.name}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 m-0 text-muted flex-fill" v-if='!rowOne&&!rowTwo'>
                            <div class="dropdown" >
                                <a href="javascript:" class="dropdown-toggle" tabindex="1" data-toggle="dropdown">
                                    <span class="beyond_one">{{this.industrysSelected}}</span>
                                </a>
                                <div class="dropdown-menu  "  style="height:auto; width: 150px;">
                                        <li v-for="(value, key) in twoRowData" class="dropdown-submenu">
                                        <a class="dropdown-item" tabindex="0" href="javascript:" @mouseenter="getChild($event)" @mouseleave="remoChilde($event)">{{value.name}}</a>
                                        <div class="dropdown-menu muneTwo">
                                             <a class="dropdown-item"  v-for="(item, key) in value.childids" @click="filtrateindust($event,key,item)" href="javascript:">{{item.name}}</a>

                                        </div>
                                        </li>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row nano video_breviary m-0 information_list wenzlist">
                    <div class="nano-content" id="home_right_list" :class="{'cur':!viewToggle}">
                        <ul class="list-unstyled" v-if="homeLists.length>0">

                            <li v-if="!isCountry" v-for="(homeList,index) in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom" :key="index">

                                <img v-if="homeList.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="subImage(homeList.thumb)" />
                                <div class="media-body">
                                    <h5>
                                        <router-link  class="f15 text-dark font-weight-bold " :to ="{name:'intellectualId',params :{contentid:homeList.id}}">{{ homeList.title }}</router-link>
                                    </h5>

                                    <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
                                        <span>{{ homeList.description}}</span>
                                    </div>

                                    <div class="clearfix" style="line-height: 22px;">
                                        <div class="float-left" v-if="homeList.published">
                                            <span class="f12 text-muted">{{homeList.published}}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li v-if="isCountry" v-for="(homeList,index) in homeLists" class="cuntryItem media pb-4 pt-4 pl-4 pr-3 border-bottom" :key="index">
                                <img src="../../../assets/images/silkRoadBase/pdfdemo.png"  class="mr-3" alt="" />
                                <div class="media-body">
                                    <h5 @click="getIframeUrl(homeList.url,index)" :class="activeIndex==index ? 'cur' : '' ">{{homeList.name}}</h5>
                                    <span>语言：{{homeList.lauage}}</span>
                                    <span>公布日期：{{homeList.date}}</span>
                                </div>
                            </li>
                            <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>

                        </ul>
                        <div v-if="endShow" class="w-100">
                            <p class="text-center p-2">此栏目暂时无数据....</p>
                        </div>
                        <div v-if="homeLists.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="" />
                            <p class="text-center p-2">暂无数据</p>

                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="!is_pay" class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':viewToggle||clickToggle,'d-none':viewToggle||clickToggle}">

            <articles :viewToggle="viewToggle" :clickToggle="clickToggle" v-if="!isCountry"></articles>
            <!--<iframe :src="iframeUrl"  frameborder="0" id="ifra" class="w-100 h-100" ></iframe>-->
            <iframe class="w-100 h-100" v-if="isCountry" ref="iframe" @onload="isFalse"  name="" :src="'https://img.imsilkroad.com/pdf/web/viewer.html?file='+encodeURIComponent(iframeUrl)"></iframe>
            <!--<embed :src="iframeUrl"  class="w-100 h-100" v-if="isCountry"></embed>-->
            <!--<img src="../../../assets/images/silkRoadBase/no_data.png" v-if="isCountry" alt="" class="mynodata">-->
        </div>

            <div class="col-md-12 mt-3 pl-3 none_gauge" v-if="this.is_pay">
<div class="charge_hint nano w-100 h-100">
    <div class="centre_content nano-content">
        <div class="card text-center p-3 pb-0">
            <div class="card-body p-0 mycard">
                <h5 class="mt-3 mb-3">
                    <img src="../../../assets/images/silkRoadBase/member.png" class="mr-2" />
                    VIP专享
                </h5>
                <h4 class="f20 fn600">此内容为付费内容</h4>
                <p class="card-text f15 text-secondary mt-3 mb-3">充值成为VIP，立享新华丝路独家服务</p>
                <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">立即开通</a>
                <p class="mt-5 mb-5">更多VIP特权功能</p>
                <div class="d-flex row justify-content-around m-0">
                    <div class="card col-md-4 col-12 p-0">
                        <div class="card-body">
                            <img src="../../../assets/images/silkRoadBase/56878730129766812.png" />
                            <h5 class="card-title mt-3 mb-3">分析师服务</h5>
                            <h6 class="card-subtitle mb-2 text-muted">新华社180个海外分支 首席记者观察与互动交流</h6>
                        </div>
                    </div>
                    <div class="card col-md-4 col-12 p-0">
                        <div class="card-body">
                            <img src="../../../assets/images/silkRoadBase/41408370476170076.png" />
                            <h5 class="card-title mt-3 mb-3">咨询服务</h5>
                            <h6 class="card-subtitle mb-2 text-muted">全球100多家顶尖智库与 咨询机构研究动态与成果</h6>
                        </div>
                    </div>
                    <div class="card col-md-4 col-12 p-0">
                        <div class="card-body">
                            <img src="../../../assets/images/silkRoadBase/507574572099684577.png"/>
                            <h5 class="card-title mt-3 mb-3">海外活动服务</h5>
                            <h6 class="card-subtitle mb-2 text-muted">最新海内外投资项目 查询与发布</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</div>
    </div>
</template>
<script>
    import articles from './ArticleDetails/Article.vue'
    // import nodata from 'images/no_data.png'
    export default({
        name: 'intellectual',
        data: function() {
            return {
                nations: [],
                classifys: [],
                industrys: [],
                homeLists: [],
                probations: [], //试读
                nationsSelected: '',
                classifysSelected: '',
                industrysSelected: '',
                industryID: '0', //分类ID
                page: 1,
                total_page: 1,
                probationes: [],
                firstlist: '',
                token: '',
                viewToggle:true,
                clickToggle:true,
                loadShow:true,
                endShow:false,
                rowOne:true,
                rowTwo:false,
                twoRowData:[],
                activeID:"",
                isCountry:false,
                iframeUrl:"",
                activeIndex:0,
                is_pay:0
            }
        },
        created: function() {
            var self = this;

            // 检查用户权限
            this.$axios.post('/api/pc/checkpagepermission', {'type':'intellectual'}).then(function (response) {
                if (response.data.state) {
                    self.is_pay = response.data.data.is_pay;
                }
            })

            this.viewToggle=this.IsPC();
            //请求select框
            this.$axios.post('/api/pc/intellectuacate').then((data)=>{
                this.nations = data.data.data; //国家
                this.nationsSelected=this.nations[0].name;
                this.activeID=this.nations[0].id;
            }).then(function () {
                this.getData();
            });
            this.$axios.post('/api/pc/intellectuacountry').then((data)=>{
                this.industrys = data.data.data; //国家
            })
        },

        mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
            this.load();
        },
        methods: {
            isFalse(){
                console.log(1111)
            },
            clickToggles(){
                this.clickToggle=false;
            },
            getIframeUrl(url,num){
                this.activeIndex=num;
                this.iframeUrl=url
            },
            getCountry(){
                var self=this;
                var param={}
                param.proid=this.activeID;
                self.homeLists=[];
                this.$axios.post('/api/pc/intellectuadetail',param).then((res)=>{
                    let{data,state}=res.data;
                    if(state){

                        data&&data.length>0&&(this.homeLists=data);
                        self.loadShow=false;
                    }
                }).then(function () {
                    this.iframeUrl=this.homeLists[0].url;
                    this.activeIndex=0;
                });
            },
            clickToggles(){
                this.clickToggle=false;
            },
            getData(){
                var self=this;
                    var param={}
                    param.id=this.activeID;
                    param.current_page=this.page;
                    param.page_size=8;
                    self.homeLists=[];
                    this.$axios.post('/api/pc/intellectualist',param).then((res)=>{
                        let{data,state}=res.data;
                        if(state){
                            self.homeLists=[];
                            data.content&&data.content.length>0&&(this.homeLists=data.content);
                            self.total_page=data.total;
                            self.loadShow=false;
                        }
                }).then(function () {
                    if(self.homeLists.length>0&&self.homeLists[0].id) {
                        self.$router.push({
                            name: 'intellectualId',
                            params: {
                                contentid: self.homeLists[0].id,
                            }
                        });
                    }
                    });

            },
            getChild(e){

                $(e.target).siblings(".dropdown-menu").show()
            },
            remoChilde(e){
                $(e.target).siblings(".dropdown-menu").hide()
            },
            goback(){
                if(this.viewToggle){
                    this.$router.push({name:'intellectual'})
                }else{
                    this.clickToggle=true;
                }

            },
            filtrateClassifys: function(val) { //国家
                this.nationsSelected=val.name;
                var that=this;
                this.page=1;
                $.each(that.nations,function(i,elm){
                    if(val.name=="IP法律法规"){
                        that.twoRowData=that.industrys;
                        that.industrysSelected=that.twoRowData[0].childids[0].name;
                        that.activeID=that.twoRowData[0].childids[0].proid;
                        that.rowOne=false;
                        that.rowTwo=false;
                        that.isCountry=true;
                        that.getCountry();
                        return false
                    }
                    if(elm.name==val.name){
                        if(elm.children){
                            that.twoRowData=elm.children;
                            that.industrysSelected=that.twoRowData[0].name;
                            that.nationsSelected=val.name;
                            that.activeID=that.twoRowData[0].id;
                            that.rowOne=false;
                            that.isCountry=false;
                            that.rowTwo=true;
                            that.getData();
                        }else{
                            that.activeID=val.id;
                            that.nationsSelected=val.name;
                            that.rowOne=true;
                            that.isCountry=false;
                            that.getData();
                            that.rowTwo=true;
                        }
                    }
                })


            },
            filtrateindustry(key,value){
                this.activeID=value.id;
                this.industrysSelected=value.name;
                this.isCountry=false;
                this.getData();
            },
            filtrateindust(e,key,value){
                this.activeID=value.proid;
                this.industrysSelected=value.name;
                this.isCountry=true;
                this.getCountry();
                $(e.target).parent().hide();
            },
            handleScroll() {
                if(this.isCountry)return false;
                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度

                if(((all - 20) < (top + client)) && !this.loadShow) {
                    this.page++;
                    if(this.page > this.total_page) {
                        this.endShow = true;
                        return;
                    }
                    this.loadShow = true;
                    var self = this;
                    var param={}
                    param.id=this.activeID;
                    param.current_page=this.page;
                    param.page_size=8;
                    this.$axios.post('/api/pc/intellectualist', param).then(function(res) {
                        let{data,state}=res.data;
                        data.content&&data.content.length>0&&(this.homeLists=this.homeLists.concat(data.content));
                        self.total_page = data.total;
                        self.loadShow = false;
                    }, function(response) {
                        console.info(response);
                        if(response) {
                            console.log("失败");
                        }
                    })
                }

            },
            timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

                if(days > 0) {
                    if (days > 7) {
                        var time = new Date(published);
                        var m = time.getMonth()+1;
                        var d = time.getDate();
                        return m + '-' + d;
                    } else {
                        if(days==1){
                            return days + 'day ago';
                        }
                        return days + 'days ago';
                    }
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
                if (seconds > 0) {
                    if(seconds==1){
                        return  seconds + 'second ago';
                    }
                    return  seconds + 'seconds ago';
                }
            },
            subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');
                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
            subImage(thumb) {
                // 处理组图的显示
                var start = thumb.indexOf('|');

                if (start > 0) {
                    var arr = thumb.split('|');
                    return arr[1];
                } else {
                    return thumb;
                }
            }

        },
        watch: {
            $route: {
                handler: function(val, oldVal) {
                    var self = this;
                    let that = this;
                    if(this.$route.params.contentid) {

                    } else {
                        var param={}
                        param.id=this.activeID;
                        param.current_page=this.page;
                        param.page_size=8;
                        this.$axios.post('/api/pc/intellectualist',param).then((res)=>{
                            let{data,state}=res.data;
                            if(state){
                                this.homeLists=[];
                                data.content&&data.content.length>0&&(this.homeLists=data.content);
                                this.total_page=data.total;
                                this.loadShow=false;
                            }
                        }).then(function () {
                            if(homeLists[0].id) {
                                that.$router.push({
                                    name: 'intellectualId',
                                    params: {
                                        contentid: homeLists[0].id,
                                    }
                                });
                            }
                        });

                    }

                },
                deep: true
            }
        },
        components: {
            articles
        }
    })
</script>
<style scoped type="text/css">
    .cuntryItem{

    }
    .cuntryItem h5:hover{
        cursor:pointer;
    }
    .cuntryItem h5{
        font-size:15px;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:21px;
    }
    .cuntryItem h5.cur{
        color:#208EFF;
    }
    .cuntryItem img{
        width:36px;
        height:40px;
        margin-top: 6px;
    }
    .cuntryItem span{
        font-size:13px;
        font-weight:400;
        color:rgba(144,146,166,1);
        line-height:18px;
    }
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    .dropdown-menu:hover{
        display: block!important;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .card-subtitle{
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:20px;
    }
    .muneTwo{
        width: 150px;
        max-height: 300px;
        left: 150px;
        top: 0;
        overflow-y: auto;
    }
    .beyond_one{
        max-width: 120px;
    }
    @media screen and (max-width: 800px) {
        .nmd{
            left:-150px
        }
        .muneTwo{
            left: -150px;
        }
    }
</style>
